import { Calendar, Check, Clock, Eye, FileText, Send, X } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export type QuoteStatus = "draft" | "sent" | "viewed" | "accepted" | "rejected" | "scheduled";

interface StatusBadgeProps {
  status: QuoteStatus;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const getStatusConfig = (status: QuoteStatus) => {
    switch (status) {
      case "draft":
        return {
          label: "Draft",
          icon: FileText,
          variant: "secondary" as const,
          className: "bg-gray-100 text-gray-800 border-gray-200",
        };
      case "sent":
        return {
          label: "Sent",
          icon: Send,
          variant: "default" as const,
          className: "bg-blue-100 text-blue-800 border-blue-200",
        };
      case "viewed":
        return {
          label: "Viewed",
          icon: Eye,
          variant: "default" as const,
          className: "bg-purple-100 text-purple-800 border-purple-200",
        };
      case "accepted":
        return {
          label: "Accepted",
          icon: Check,
          variant: "default" as const,
          className: "bg-green-100 text-green-800 border-green-200",
        };
      case "rejected":
        return {
          label: "Rejected",
          icon: X,
          variant: "destructive" as const,
          className: "bg-red-100 text-red-800 border-red-200",
        };
      case "scheduled":
        return {
          label: "Scheduled",
          icon: Calendar,
          variant: "default" as const,
          className: "bg-emerald-100 text-emerald-800 border-emerald-200",
        };
      default:
        return {
          label: "Unknown",
          icon: Clock,
          variant: "secondary" as const,
          className: "bg-gray-100 text-gray-800 border-gray-200",
        };
    }
  };

  const config = getStatusConfig(status);
  const Icon = config.icon;

  return (
    <Badge
      variant={config.variant}
      className={`${config.className} ${className} flex items-center gap-1`}
    >
      <Icon className="w-3 h-3" />
      <span>{config.label}</span>
    </Badge>
  );
}
